var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import Modal from 'react-modal';
import { useHistory } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';
import api from '../../../services/api';
import * as Yup from 'yup';
import styles from './styles.module.scss';
import { Button, InputSelect } from 'template/lib';
Modal.setAppElement('#root');
var ModalAttendant = function (props) {
    var history = useHistory();
    var _a = useAuth(), login = _a.login, handleLogout = _a.handleLogout;
    var _b = useState([]), supportUsers = _b[0], setSupportUsers = _b[1];
    var _c = useState([]), softwares = _c[0], setSoftwares = _c[1];
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    var attendantSchema = Yup.object().shape({
        userId: Yup.string().required('Por favor, informe um usuário.'),
    });
    var formik = useFormik({
        initialValues: {
            userId: '',
            active: true,
            softwareIds: []
        },
        validationSchema: attendantSchema,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () {
            var payload, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        payload = __assign(__assign({}, values), { softwareIds: values.softwareIds.map(Number) });
                        return [4 /*yield*/, api.post('attendants', payload, config)];
                    case 1:
                        _a.sent();
                        formik.resetForm();
                        props.setRefresh(function (prev) { return !prev; });
                        props.handleCloseModalAttendant();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        if (!login || Date.now() > login.expiresIn * 1000) {
                            handleLogout();
                            history.push('/');
                            return [2 /*return*/];
                        }
                        console.log(err_1);
                        alert('Erro ao cadastrar atendente.');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    });
    useEffect(function () {
        if (login && Date.now() > login.expiresIn * 1000) {
            handleLogout();
            history.push('/');
            return;
        }
        if (!login) {
            history.push('/');
            return;
        }
        api.get('helps/softwares', config).then(function (response) {
            setSoftwares(response.data);
        });
    }, []);
    useEffect(function () {
        if (props.modalIsOpenAttendant) {
            formik.resetForm();
            api.get('attendants/get-support-users', config).then(function (response) {
                setSupportUsers(response.data);
            });
        }
    }, [props.modalIsOpenAttendant]);
    var supportUsersSelect = {
        label: 'Usuário',
        options: supportUsers
    };
    var softwareSelect = {
        label: 'Softwares atendidos',
        options: softwares
    };
    return (_jsx(Modal, __assign({ isOpen: props.modalIsOpenAttendant, shouldCloseOnOverlayClick: false, onRequestClose: props.handleCloseModalAttendant, overlayClassName: 'react-modal-overly', className: 'react-modal-content', contentLabel: "Novo Atendente" }, { children: _jsxs("div", { children: [_jsxs("div", __assign({ className: styles.header }, { children: [_jsx("div", {}, void 0), _jsx("h2", __assign({ className: 'font-semibold border-b-2 text-lg' }, { children: "Novo Atendente" }), void 0), _jsx(AiOutlineClose, { title: 'Fechar', className: 'cursor-pointer text-sm', onClick: props.handleCloseModalAttendant }, void 0)] }), void 0), _jsx("div", __assign({ className: styles.content }, { children: _jsxs("form", __assign({ onSubmit: formik.handleSubmit, className: 'mx-4 my-4' }, { children: [_jsx("div", __assign({ className: 'grid justify-items-start' }, { children: _jsxs("div", __assign({ className: 'grid grid-cols-1 my-2 justify-items-end' }, { children: [_jsxs("div", __assign({ className: styles.containerCheckBoxInput }, { children: [_jsx("label", __assign({ className: styles.labelActive }, { children: "Ativo:" }), void 0), _jsx("input", { onChange: formik.handleChange, name: 'active', type: "checkbox", checked: formik.values.active }, void 0)] }), void 0), _jsx(InputSelect, { onChange: formik.handleChange, value: formik.values.userId, name: 'userId', values: supportUsersSelect, valueMember: 'id', displayMember: 'name', firstOption: 'Selecione um usu\u00E1rio' }, void 0), formik.errors.userId && formik.touched.userId && (_jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.userId }), void 0)), _jsxs("div", __assign({ className: styles.multiSelectContainer }, { children: [_jsx("label", __assign({ className: styles.multiSelectLabel }, { children: "Softwares atendidos:" }), void 0), _jsx("div", __assign({ className: styles.multiSelectBox }, { children: softwares.map(function (software) {
                                                        var softwareId = Number(software.id);
                                                        var selected = formik.values.softwareIds.includes(softwareId);
                                                        return (_jsxs("label", __assign({ className: styles.multiSelectOption + " " + (selected ? styles.multiSelectOptionSelected : '') }, { children: [_jsx("input", { type: "checkbox", name: "softwareIds", value: softwareId, checked: selected, onBlur: function () { return formik.setFieldTouched('softwareIds', true); }, onChange: function (e) {
                                                                        var currentIds = formik.values.softwareIds;
                                                                        if (e.target.checked) {
                                                                            formik.setFieldValue('softwareIds', __spreadArray(__spreadArray([], currentIds), [softwareId]));
                                                                        }
                                                                        else {
                                                                            formik.setFieldValue('softwareIds', currentIds.filter(function (id) { return id !== softwareId; }));
                                                                        }
                                                                    } }, void 0), _jsx("span", { children: software.name }, void 0)] }), softwareId));
                                                    }) }), void 0)] }), void 0), formik.errors.softwareIds && formik.touched.softwareIds && (_jsx("i", __assign({ className: styles.formikErrors }, { children: formik.errors.softwareIds }), void 0))] }), void 0) }), void 0), _jsx("div", __assign({ className: styles.flexButton }, { children: _jsx(Button, __assign({ type: 'submit' }, { children: "Salvar" }), void 0) }), void 0)] }), void 0) }), void 0)] }, void 0) }), void 0));
};
export default ModalAttendant;
